<template>
  <div>
    <b-card>
      <b-form @submit.prevent="onSearch(tab)">
        <b-row>
          <template
            v-for="(searchEntity, searchIndex) of tab.searchForm.searchEntities"
          >
            <b-col cols="6" class="mb-4">
              <b-select
                v-model="searchEntity.searchField"
                :options="searchFields"
              />
            </b-col>
            <b-col cols="6" class="mb-4">
              <b-input-group>
                <b-input
                  v-model.trim.lazy="searchEntity.searchValue"
                  @change="changeField(searchEntity, tab)"
                  @focus="addField(tab)"
                />
                <!--                    <b-input-->
                <!--                      v-model.trim="searchEntity.searchValue"-->
                <!--                      @change="-->
                <!--                        initializeOtherFields(tab);-->
                <!--                        changeField(searchEntity, tab);-->
                <!--                      "-->
                <!--                    />-->
                <b-input-group-append>
                  <b-select v-model="searchEntity.searchType">
                    <b-select-option value="=">Perfect</b-select-option>
                    <b-select-option value="like">Partial</b-select-option>
                    <b-select-option value="!=">Not</b-select-option>
                    <b-select-option value=">=">&gt;=</b-select-option>
                    <b-select-option value="<=">&lt;=</b-select-option>
                  </b-select>
                  <b-btn
                    variant="warning"
                    @click="deleteField(searchIndex, tab)"
                  >
                    X
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </template>
          <b-col cols="6">
            <b-form-group label="View">
              <b-form-radio-group
                v-model="tab.parentTable"
                :options="parentTables"
                button-variant="outline-primary"
                size="md"
                name="radio-btn-outline"
                buttons
                @change="chooseTable(tab)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Adddress & Customs Status">
              <b-form-checkbox-group v-model="tab.searchForm.subStatusArr">
                <b-checkbox value="-1">Address problem</b-checkbox>
                <b-checkbox value="20">clearance started</b-checkbox>
                <b-checkbox value="21">2 day stale</b-checkbox>
                <b-checkbox value="22"> Pending</b-checkbox>
                <b-checkbox value="23">Failed</b-checkbox>
                <b-checkbox value="30">Waiting for collection</b-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Region">
              <b-form-radio-group
                id="btn-radios-2"
                v-model="tab.searchForm.region"
                :options="regions"
                button-variant="outline-primary"
                size="md"
                name="radio-btn-outline"
                buttons
                @change="chooseRegion"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Status">
              <b-form-checkbox-group v-model="tab.searchForm.statusArr">
                <b-checkbox value="-1"> ID unmatched</b-checkbox>
                <b-checkbox value="0"> Processing</b-checkbox>
                <b-checkbox value="1"> Errored</b-checkbox>
                <b-checkbox value="2"> Bought</b-checkbox>
                <b-checkbox value="3"> All Bought</b-checkbox>
                <b-checkbox value="4"> Arrived</b-checkbox>
                <b-checkbox value="5"> Shipped</b-checkbox>
                <b-checkbox value="6"> Cancelling</b-checkbox>
                <b-checkbox value="7"> Cancelled</b-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-btn type="submit"> Submit</b-btn>
            <b-btn type="button" @click="searchNewTab(tab)">
              Submit(New tab)
            </b-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-row class="my-3">
      <b-col cols="2">
        <b-select v-model="perPage" :options="perPages" @change="search(tab)" />
      </b-col>
      <b-col>
        <b-pagination
          v-model="currentPage"
          align="center"
          class="my-3"
          :limit="10"
          :total-rows="100"
          :per-page="10"
        />
<!--        <span v-for="(idx, page) in pages" :key="page">-->
<!--          <b-btn @click="getPage(idx)">{{ page + 1 }}</b-btn>-->
<!--        </span>-->
<!--        <b-btn @click="getNextPage">Next Page</b-btn>-->

      </b-col>
    </b-row>
  </div>
</template>
<script>
const axios = require("axios");
import searchFields from "./order-fields.json";

export default {
  name: "OrderList",
  components: {},
  data() {
    const favoriteFields = [
      { text: "User ID", value: "userid;logis" },
      { text: "User ID", value: "userid;fees" },
      { text: "User ID", value: "userid;orders" },
      { text: "Package No", value: "idx;logis" },
      {
        text: "Order No",
        value: "idx;orders",
      },
      { text: "Recipient Name", value: "name;logis" },
    ];
    const optionalFields = searchFields.map((key) => ({
      text: key,
      value: key,
    }));
    const allFields = favoriteFields.concat(optionalFields);
    return {
      show: { adr: false },
      searchFields,
      pages: [],
      showSummary: false,
      perPage: 20,
      perPages: [20, 50, 100, 200, 300].map((perPage) => {
        return {
          text: "Show " + perPage,
          value: perPage,
        };
      }),
      rates: [],
      CNYUSD: 0,
      openBulkModalKey: "",
      openModalIdx: 0,
      currentTab: 0,
      changeLogs: [],
      changeLogFields: [
        {
          key: "createdAt",
          label: "Time",
          stickyColumn: true,
          isRowHeader: true,
        },
      ],
      allFields,
      parentTables: [
        { value: "fees", text: "domestic" },
        { value: "logis", text: "shipping" },
        { value: "orders", text: "orders" },
      ],
      regions: ["US", "CN", "DE", "JP", ""],
      checkedItems: [],
      newQty: 0,
      splitQty: 0,
      splitIdx: 0,
      stateColors: {
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
      },
      currentBulkKey: "",
      currentOrder: {},
      currentId: 0,
      form: {
        // url: "",
        // cnt: "",
        price: "",
        // charge: ""
      },
      //TODO: Later change the DB and make declaredUnitPrirce,marketTotalPrice,discountedTotalPrice
      //the discount will be marketTotalPrice-declaredTotalPrice
      editFormParent: [
        { name: "Country", key: "region" },
        { key: "name", text: "Name", value: "" },
        { key: "hand", text: "Phone", value: "" },
        { key: "adr1", text: "address 1", value: "" },
        { key: "adr2", text: "address 2", value: "" },
        { key: "city", text: "city", value: "" },
        { key: "province", text: "province", value: "" },
        { key: "zip", text: "zip code", value: "" },
        { key: "countryCode", text: "country code", value: "" },
        { key: "idno", text: "ID Number", value: "" },
        { key: "tnum", text: "HBL No", value: "" },
        { key: "email", text: "email", value: "" },
        { key: "managermemo", text: "Manager memo", value: "" },
        { key: "desc", text: "Packing memo", value: "" },
        { key: "memo", text: "Delivery memo", value: "" },
        { key: "errmemo", text: "Issue", value: "" },
      ],
      editGroupParent: [
        { name: "Country", key: "region" },
        { name: "Name", key: "name" },
        { name: "Phone", key: "hand" },
        { name: "address 1", key: "adr1" },
        { name: "address 2", key: "adr2" },
        { name: "city", key: "city" },
        { name: "province", key: "province" },
        { name: "zip code", key: "zip" },
        { name: "country code", key: "countryCode" },
        { name: "ID Number", key: "idno" },
        { name: "HBL No", key: "tnum" },
        { name: "email", key: "email" },
        { name: "Defer status", key: "defer" },
        { name: "Internal memo", key: "savemsg" },
        { name: "Packing memo", key: "desc" },
      ],
      editGroupIssues: [
        { name: "Discounted Total Price", key: "costTotal" },
        { name: "Order No.", key: "trade_id" },
      ],
      editGroupCN: [{ name: "HS Code", key: "hscode" }],
      editGroup: [
        { name: "Country", key: "region" },
        { name: "Declared unit price", key: "price" },
        { name: "Qty", key: "cnt" },
        { name: "Market Total Price", key: "declarePrice" },
        { name: "Estimated Weight", key: "estWeight" },
        { name: "Discounted Total Price", key: "costTotal" },
        { name: "Unit Revenue", key: "charge" },
        { name: "Market ID", key: "marketId" },
        { name: "Order No.", key: "trade_id" },
        { name: "URL", key: "url" },
        { name: "Image URL", key: "img" },
        { name: "Title", key: "title" },
        // { name: "bought Date", key: "procuredAt" },
        { name: "Alternative title", key: "titleOrg" },
        { name: "category", key: "category" },
        { name: "hs code", key: "hscode" },
        { name: "clone No.", key: "cloneSeq" },
        { name: "Delivery Info", key: "deliverydate_info" },
        { name: "Arrives At", key: "arrivesAt" },
        { key: "error" },
        { key: "status" },
        // { key: "logicode" },
        // { key: "feecode" },
        { name: "Short Tracking", key: "stnum" },
        { name: "Tracking", key: "tnum" },
      ],
      tabs: [
        {
          title: "Basic",
          parentTable: "logis",
          searchForm: {
            statusArr: [],
            subStatusArr: [],
            region: "",
            searchEntities: [
              {
                searchValue: "",
                searchField: "userid;logis",
                searchType: "=",
              },
              {
                searchValue: "",
                searchField: "name;logis",
                searchType: "=",
              },
              {
                searchValue: "",
                searchField: "title;orders",
                searchType: "like",
              },
            ],
          },
          parents: [{}],
        },
        {
          title: "Adr issues JP",
          parentTable: "logis",
          searchForm: {
            statusArr: [-1],
            // subStatusArr: [-1],
            region: "",
            searchEntities: [
              {
                searchValue: "JP",
                searchField: "countryCode;logis",
                searchType: "=",
              },
            ],
          },
          parents: [{}],
        },
        {
          title: "Stock",
          parentTable: "logis",
          searchForm: {
            statusArr: [],
            isMarket: false,
            region: "",
            searchEntities: [
              {
                searchValue: "4",
                searchField: "status;orders",
                searchType: "=",
              },
              {
                searchValue: "0",
                searchField: "paid;orders",
                searchType: ">=",
              },
              {
                searchValue: "1",
                searchField: "internal;orders",
                searchType: "=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "Issues",
          parentTable: "fees",
          searchForm: {
            statusArr: [],
            isMarket: false,
            region: "",
            searchEntities: [
              {
                searchValue: "1",
                searchField: "status;orders",
                searchType: "=",
              },
              {
                searchValue: "-2",
                searchField: "paid;fees",
                searchType: "!=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "CN orders",
          parentTable: "orders",
          searchForm: {
            statusArr: ["0"],
            isMarket: false,
            region: "CN",
            searchEntities: [
              {
                searchValue: "3",
                searchField: "selfbuy;orders",
                searchType: "=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "ID match",
          parentTable: "logis",
          searchForm: {
            statusArr: ["-1"],
            region: "",
            searchEntities: [
              {
                searchValue: "KR",
                searchField: "countryCode;logis",
                searchType: "=",
              },
              {
                searchField: "status;orders",
                searchValue: "7",
                searchType: "!=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "Customs issues",
          parentTable: "logis",
          searchForm: {
            statusArr: ["5"],
            subStatusArr: [22, 23],
            searchEntities: [
              {
                searchField: "selfbuy;logis",
                searchValue: "3",
                searchType: "=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "Customs delayed",
          parentTable: "logis",
          searchForm: {
            statusArr: ["5"],
            subStatusArr: [20],
            searchEntities: [
              {
                searchField: "deferday;logis",
                searchValue: new Date(
                  Date.now() - 3 * 86400 * 1000,
                ).toISOString(),
                searchType: "<=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "Refunded",
          parentTable: "logis",
          searchForm: {
            statusArr: [],
            searchEntities: [
              {
                searchField: "selfbuy;logis",
                searchValue: "3",
                searchType: "=",
              },
              {
                searchField: "paid;logis",
                searchValue: "-3",
                searchType: "=",
              },
              {
                searchField: "status;logis",
                searchValue: "7",
                searchType: "!=",
              },
            ],
          },
          parents: [
            {
              orders: [
                {
                  arrivesIn: 0,
                },
              ],
            },
          ],
        },
        {
          title: "Old",
          parentTable: "logis",
          searchForm: {
            statusArr: [],
            listType: "old",
            isMarket: true,
            searchEntities: [
              {
                searchValue: new Date().toISOString(),
                searchField: "arrivesAt;orders",
                searchType: "<=",
              },
              {
                searchValue: "2",
                searchField: "status;orders",
                searchType: ">=",
              },
              {
                searchValue: "3",
                searchField: "status;orders",
                searchType: "<=",
              },
            ],
          },
          parents: [{}],
        },
      ],
      fields: [
        "actions",
        "idx",
        "name",
        "hand",
        "adr",
        "weight",
        "carrier",
        "writeday",
      ],
      page: 1,
      filter: "",
      historyFilter: "",
      currentPage: 1,
      current: [],
      items: [],
      currentFields: {
        img: {},
        title: {
          sortable: true,
        },
        size: {},
        qty: {
          sortable: true,
        },
      },
      total: 0,
      stockData: "",
    };
  },
  watch: {
    $route: "init",
    currentPage(currentPage) {
      console.log(currentPage);
      this.$router.push({
        query: { ...this.$route.query, currentPage, perPage: this.perPage },
      });
      this.search(this.tabs[this.currentTab]);
    },
  },
  props: ["tab"],

  methods: {
    showImg(img) {
      if (img.includes("shopping-phinf.pstatic.net"))
        return "https://api.uniauc.com/image?url=" + img;
      else return img;
    },
    clearParentFields(modalId) {
      this.editFormParent.forEach((field) => {
        field.value = "";
      });
    },
    getPage(lastIdx) {
      const tab = this.tabs[this.currentTab];
      this.$router.push({
        query: { ...this.$route.query, lastIdx, perPage: this.perPage },
      });
      console.log(lastIdx);
      this.init();
    },
    async getNextPage() {
      const tab = this.tabs[this.currentTab];
      const lastIdx = tab.parents ? tab.parents.pop().idx : "";
      const searched = await this.search(tab, lastIdx);
      if (searched) this.pages.push(lastIdx);
    },
    searchUser(userid) {
      this.tabs[this.currentTab].searchForm.searchEntities.push({
        searchField: "userid;logis",
        searchValue: userid,
        searchType: "=",
      });
      this.search(this.tabs[this.currentTab]);
    },
    async ban(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/ban", { uid: order.itemCode });
        if (error) this.$warn(error);
        else this.$warn("banned");
      }
    },
    async unban(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/unban", { uid: order.itemCode });
        if (error) this.$warn(error);
        else this.$warn("unbanned");
      }
    },
    async banSeller(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/ban-seller", {
          uid: order.itemCode,
        });
        if (error) this.$warn(error);
        else this.$warn("banned");
      }
    },
    async unbanSeller(order) {
      if (window.confirm("Proceed?")) {
        const { error } = await axios.post("/unban-seller", {
          uid: order.itemCode,
        });
        if (error) this.$warn(error);
        else this.$warn("unbanned");
      }
    },
    async onWeightSubmit(logi) {
      await this.updateLogis(logi, { weight: logi.weight });
      await this.printBL(logi);
    },
    printInvoice(fee) {
      window.open(`https://api.resell.glocing.com/invoice/${fee.logicode}`);
    },
    printBL(fee) {
      if (fee.feecode)
        window.open("https://api.uniauc.com/create-sgw-awb/" + fee.feecode);
      if (fee.logicode)
        window.open("https://api.uniauc.com/create-sgw-awb/" + fee.logicode);
    },
    pushChangeObj(obj, order) {
      Object.entries(obj).forEach(([key, val]) => {
        this.pushChange(order, key, val);
      });
    },
    onClickRegion(fee, evt) {
      const region = evt.target.value;
      if (!region) return;
      console.log(region);
      let currencyRate;
      if (region === "CN") {
        currencyRate = 1 / this.CNYUSD;
      } else if (region === "US") {
        currencyRate = 1;
      }
      fee.orders.forEach((order) => {
        order.region = region;
        order.price = ((order.declarePrice * currencyRate) / order.cnt).toFixed(
          2,
        );

        order.costTotal = (order.costTotal * (1 / currencyRate)).toFixed(2) * 1;

        if (region === "CN")
          order.trade_id = `Taobao ${new Date().toLocaleDateString()}`;

        const changeObj = {
          region: region,
          price: order.price,
          trade_id: order.trade_id,
        };
        this.pushChangeObj(changeObj, order);
      });

      this.$forceUpdate();
    },
    async getChangeLog(table, idx) {
      const { data: changeLogs } = await axios.get(`/get-change-log`, {
        params: {
          id: idx,
          tableName: table,
        },
      });
      for (const changeLog of changeLogs) {
        const fields = JSON.parse(changeLog.data);
        for (const fieldKey in fields) {
          this.changeLogFields.push({
            key: fieldKey,
            label: fieldKey,
          });
          changeLog[fieldKey] = fields[fieldKey];
        }
      }
      this.changeLogs = changeLogs;

      this.$bvModal.show("changeLogModal");
    },
    async updateLogis(logi, postData) {
      const { data } = await axios.post(`/update-logis/${logi.idx}`, postData);
      if (data.msg === "ok") {
        logi.currentState = "changed";
        this.$forceUpdate();
        this.$warn("updated");
      }
    },
    modifyId({ idx, zip }) {
      const url = `https://v5.uniauc.com/submit-id/${idx}/${zip}`;
      window.open(url);
    },
    chooseRegion(region) {
      // tab.searchForm.searchEntities.push({
      //   searchField: key,
      //   searchValue: tab.searchForm.region
      // })
    },
    chooseTable(tab) {
      this.searchFields = this.allFields.filter(
        (field) =>
          field.value.includes(tab.parentTable) ||
          field.value.includes("orders"),
      );
    },
    goto(row) {
      location.href = `#${row.item.idx}`;
    },
    deleteField(searchIndex, tab) {
      tab.searchForm.searchEntities.splice(searchIndex, 1);
    },
    initializeOtherFields(tab) {
      const { searchForm } = tab;
      searchForm.statusArr = [];
      searchForm.isMarket = false;
      searchForm.region = "";
    },
    changeField(searchEntity, tab) {
      const input = searchEntity.searchValue.trim();
      if (
        // fedex
        /^\d{12}$/.test(input) ||
        // kpost
        /^6\d{12}$/.test(input)
      ) {
        searchEntity.searchField = "tnum;logis";
      } else if (/ /.test(input)) {
        searchEntity.searchField = "title;orders";
        searchEntity.searchType = "=";
      } else if (/^[a-z]{3}$/.test(input)) {
        searchEntity.searchField = "carrier;logis";
      } else if (/3\d{7}$/.test(input)) {
        searchEntity.searchField = "idx;logis";
      } else if (/5\d{7}$/.test(input)) {
        searchEntity.searchField = "idx;orders";
      } else if (/^B\w{9}$/.test(input)) {
        searchEntity.searchField = "itemCode;orders";
      } else if (/^\d{10}|[0-9-]{26}$/.test(input)) {
        searchEntity.searchField = "feecode;orders";
      } else if (/^(coupang|rakuten)$/.test(input)) {
        searchEntity.searchField = `userid;${tab.parentTable}`;
      }
    },
    addField(tab) {
      if (tab.searchForm.searchEntities.every((entity) => entity.searchValue)) {
        tab.searchForm.searchEntities.push({
          searchField: "logicode;orders",
          searchValue: "",
          searchType: "=",
        });
      }
    },
    getCarrierLink({ carrier, tnum }) {
      return `https://api.resell.glocing.com/track/${tnum}`;
    },
    async snooze() {
      const { data } = await axios.post("/order-list/snoozeBy", {});
    },
    async shipYY() {
      const { data } = await axios.post("/yy-ship");
      this.$warn(data);
    },
    async printAwb(item, carrier) {
      if (carrier === "yye")
        window.open(`https://api.uniauc.com/create-yy-awb/${item.idx}`);
    },
    async extract(tab) {
      if (!confirm("Sure?")) return false;
      this.$bvModal.hide("editModal");
      const { data } = await axios.post("extract-items", {
        idxs: this.checkedItems,
      });
      this.$warn(data);
      this.search(tab);
    },
    async copy(idx, status, userid) {
      if (!confirm("Sure?")) return false;
      const { data } = await axios.post("copy-order", {
        idx,
        status,
        userid,
      });
      this.$warn(data);
      // this.$router.push(`/order-list/logis?logicode%3Borders=${data.logicode}`);
      // this.search();
    },
    async changeQty(item) {
      this.pushChange("charge", item.charge * (item.cnt / this.newQty));
      this.pushChange("price", item.price * (item.cnt / this.newQty));
      this.pushChange("cnt", this.newQty);
    },
    async split(idx, tab) {
      this.$bvModal.hide("editModal");
      const { data } = await axios.post("split-item", {
        splitQty: this.splitQty,
        idx,
      });
      this.$warn(data);
      this.search(tab);
    },
    getCurrencyUnit(region) {
      switch (region) {
        case "KR":
          return "KR￦";
        case "JP":
          return "JP¥";
        case "CN":
          return "CN¥";
        case "US":
          return "US$";
      }
    },
    async changeHScode(order) {
      const { data } = await axios.post("/edit-order", [
        {
          idx: order.idx,
          hscode: order.hscode,
          category: order.category,
        },
      ]);
      if (data.msg === "success") {
        order.currentState = "changed";
        this.$forceUpdate();
      }
      this.$warn(data.msg);
    },
    async changeArrivesAt(order) {
      const { data } = await axios.post("/edit-order", [
        {
          idx: order.idx,
          arrivesAt: order.arrivesAt,
        },
      ]);
      if (data.msg === "success") {
        order.currentState = "changed";
        this.$forceUpdate();
      }
      this.$warn(data.msg);
    },
    pushParentChange(fee, key, evt, tab) {
      if (["name", "hand", "idno"].includes(key)) fee.idChanged = 1;
    },
    calcShipCost(order) {
      if (order.region === "CN") {
        const simpleWeight = order.logisTmpWeight || order.estWeight;
        let lastmileCost;
        if (simpleWeight < 5) lastmileCost = 0;
        else if (simpleWeight < 10) lastmileCost = 3000;
        else if (simpleWeight < 20) lastmileCost = 6000;
        else lastmileCost = 9000;

        if (!order.estWeight) order.proratedShipCost = null;
        console.log(order);
        if (order.logisTmpWeight) {
          const minimumWeight =
            order.logisTmpWeight < 1 ? 1 : order.logisTmpWeight;
          const weightProportion = order.estWeight / order.logisTmpWeight;
          console.log(minimumWeight, weightProportion, "min8imal");
          order.proratedShipCost =
            (minimumWeight * 1100 + 3300 + lastmileCost) * weightProportion;
          console.log(order.proratedShipCost, "prorated");
          console.log(minimumWeight * 1100, 3300 + lastmileCost);
          console.log(order.weight);
        }
        order.proratedShipCost =
          order.estWeight * 1100 + (3300 + lastmileCost) / order.cntTotal;
      } else {
        order.proratedShipCost =
          order.estWeight * order.unitCostFx +
          order.baseCostFx / order.cntTotal;
      }
      console.log(
        order.estWeight,
        order.unitCostFx,
        order.baseCostFx,
        order.cntTotal || order.cnt,
      );
      this.$forceUpdate();
    },
    pushChange(order, key, val) {
      if (!val) return false;
      if (key === "url") {
        if (val.includes("taobao.com")) {
          // if(order.value.includes("https://www.taobao.com")){
        }
      }
      this.$forceUpdate();
      order.changed[key] = val.trim();
    },
    pushChangeBulk(key, evt, orders) {
      orders.forEach((order) => {
        order.changed[key] = order[key];
      });
    },
    async searchNewTab(tab) {
      // cloning
      this.tabs.unshift({ ...tab });
      this.tabs[0].title = `tab ${this.tabs.length}`;
      // await this.chooseTab(this.tabs[0]);
      this.chooseTable(tab);
      this.currentTab = 0;
      this.search(this.tabs[this.currentTab]);
    },
    async onSearch(tab) {
      this.$router.push({
        path: tab.parentTable,
        query: {
          ...this.$route.query,
          searchForm: JSON.stringify(tab.searchForm),
          currentPage: this.currentPage,
          perPage: this.perPage,
        },
      });
      this.search(this.tabs[this.currentTab]);
    },
    async search(tab, idx = "") {
      if (!tab.searchForm.searchEntities[0].searchValue) {
        this.$warn("Please enter search value");
        return;
      }
      console.log(this.$route.query, "on search");
      const parentItems = await this.$getRO(`/order-list/${tab.parentTable}`, {
        params: this.$route.query,
      });
      if (!parentItems.length) {
        this.$warn("No data");
        return;
      }
      parentItems.forEach((item) => {
        item.orders.forEach((order) => {
          order.changed = {
            rate: order.currentFxRate,
          };
          order.currentState = "";
          if (order.arrivesAt) order.arrivesAt = order.arrivesAt.slice(0, 10);
        });
      });
      // tab.parents = parentItems;
      this.tabs[this.currentTab].parents = parentItems;
      this.total = parentItems.length;
      this.$forceUpdate();
      return true;
    },
    async onEdit(fee) {
      const post = fee.orders
        .map((order) => ({
          idx: order.idx,
          ...order.changed,
        }))
        .filter((order) => order !== {});
      if (post === {}) alert("nothing changed");
      else {
        await axios.post("/edit-order", post);
      }
      // await this.init();
      this.$bvModal.hide("editModal");
    },
    async onParentEdit(fee, tab) {
      const selectedLogi = fee;
      const dataToSubmit = {};
      this.editFormParent.forEach((group) => {
        dataToSubmit[group.key] = group.value;
      });

      if (tab.parentTable === "logis") {
        const { data } = await axios.post(
          `/edit-logis/${selectedLogi.idx}/${selectedLogi.zip}?status=${selectedLogi.status}`,
          dataToSubmit,
        );
        console.log("warning");
        this.$warn(data.message);
        if (data.error) {
          return false;
        }
      }
      if (tab.parentTable === "fees")
        await axios.post(`/edit-fees/${selectedLogi.idx}`, dataToSubmit);
      // await this.init();
      this.editFormParent.forEach((group) => {
        selectedLogi[group.key] = group.value;
      });
      this.$bvModal.hide("parentEditModal");
      return true;
    },
    parentEdit(fee) {
      this.openModalIdx = fee.idx;
      if (fee.status === -1) {
        this.editFormParent = [
          { key: "name", text: "Name", value: "" },
          { key: "hand", text: "Phone", value: "" },
          { key: "adr1", text: "Addresss 1", value: "" },
          { key: "adr2", text: "Addresss 2", value: "" },
          { key: "zip", text: "Zip code", value: "" },
          { key: "idno", text: "ID Number", value: "" },
        ];
      } else {
        this.editFormParent = [
          { key: "name", text: "Name", value: "" },
          { key: "hand", text: "Phone", value: "" },
          { key: "adr1", text: "address 1", value: "" },
          { key: "adr2", text: "address 2", value: "" },
          { key: "city", text: "city", value: "" },
          { key: "province", text: "province", value: "" },
          { key: "zip", text: "zip code", value: "" },
          { key: "countryCode", text: "country code", value: "" },
          { key: "idno", text: "ID Number", value: "" },
          { key: "tnum", text: "HBL No", value: "" },
          { key: "email", text: "email", value: "" },
          { key: "desc", text: "Packing memo", value: "" },
          { key: "weight", text: "weight", value: "" },
          { key: "carrier", text: "carrier", value: "" },
        ];
      }
      this.editFormParent.forEach((field) => {
        field.value = fee[field.key];
      });
      this.$bvModal.show("parentEditModal");
    },
    edit(order) {
      // this.currentOrder = tab.parents[feeIndex].orders[orderIndex];
      order.changed = {};
      this.openModalIdx = order.idx;
      this.$bvModal.show(`editModal`);
    },
    bulkEdit(fieldKey, fee, tab) {
      tab.fee.orders.forEach((order) => {
        order.changed = {};
      });
      this.openBulkModalKey = fieldKey;
      this.$bvModal.show("bulkEditModal");
    },
    async submit(stateCode, params, orderOrFee, orders, fee) {
      if (!confirm("proceed?")) return false;
      // if (
      //   stateCode === "retry" &&
      //   !confirm("sure?")
      // ) {g
      //   return false;
      // }
      const { idxs, feecode } = params;
      if (fee) await this.onEdit(fee);

      const statuses = {
        partialRetry: 0,
        retry: 0,
        confirm: 0,
        bought: 2,
        arrived: 4,
        shipped: 5,
        cancel: 6,
        canceled: 7,
        delete: 7,
      };
      const status = statuses[stateCode];

      const { data } = await axios.post("/change-status", {
        safeMode:
          !this.$route.query || this.$route.query["status;orders"] === "1"
            ? 1
            : 0,
        status,
        stateCode,
        idxs,
        // logicode:orderOrFee.logicode,
        feecode,
        uid: orderOrFee.itemCode,
        countryId: orderOrFee.countryId,
        userid: orderOrFee.userid,
        orders: orders.map(({ idx, feecode, status }) => ({
          idx,
          feecode,
          status,
        })),
      });
      if (data.msg === "ok") {
        orderOrFee.currentState = stateCode;
        orderOrFee.status = status;
        this.$forceUpdate();
      }
      this.$warn(data.msg);
    },
    async init() {
      this.$nextTick(() => {
        this.search(this.tabs[this.currentTab]);
        // this.chooseTab(this.tabs[0]);
      });
    },
    async chooseTab(tab) {
      // const query = `${tab.parentTable}?searchForm=${JSON.stringify(
      //   tab.searchForm
      // )}&lastIdx=${idx}&currentPage=${this.currentPage}&perPage=${
      //   this.perPage
      // }`;
      this.chooseTable(tab);
      this.$router.push({
        path: tab.parentTable,
        query: {
          ...this.$route.query,
          searchForm: JSON.stringify(tab.searchForm),
          currentPage: this.currentPage,
          perPage: this.perPage,
          currentTab: this.currentTab,
        },
      });
    },
    async onSubmit() {
      await this.$api.post("/stock", {
        stockData: this.stockData,
      });
      this.stockData = "";
      this.init();
    },
  },
};
</script>
<style>
.modal-fullscreen .modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}

@media (min-width: 2992px) .modal-lg {
  max-width: auto !important;
}

@media (min-width: 576px) .modal-dialog {
  max-width: auto !important;
}
</style>
